<template>
  <div>
    <base-header class="pb-6" type="">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7"></b-col>
      </b-row>

      <!-- Statistics -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card title="Organisations" type="gradient-info" sub-title="10/10" icon="fas fa-sitemap">
            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Farms" type="gradient-success" sub-title="41/41" icon="fas fa-farm">
            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Orchards" type="gradient-warning" sub-title="98/101" icon="fas fa-apple-crate">
            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Traps" type="gradient-danger" sub-title="410/827" icon="fas fa-hand-holding-box">
            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>

      <!-- Notifications -->
      <b-row>
        <b-col xl="3" md="6">
          <b-card no-body class="bg-gradient-danger border-0">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white"
                    >Service tickets</b-card-title
                  >
                  <span class="h2 font-weight-bold mb-0 text-white">123/267</span>
                  <base-progress class="progress-xs mt-3 mb-0" type="success" :value="47"></base-progress>
                </b-col>
                <b-col md="auto">
                  <b-dropdown no-caret right toggle-class="btn btn-sm btn-neutral mr-0">
                    <template v-slot:button-content>
                      <i class="fas fa-ellipsis-h"></i>
                    </template>
                    <b-dropdown-item>Reload</b-dropdown-item>
                    <b-dropdown-item>New ticket</b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
              <p class="mt-3 mb-0 text-sm">
                <a href="#!" class="text-nowrap text-white font-weight-600">See details</a>
              </p>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col xl="3" md="6">
          <b-card no-body class="bg-gradient-danger border-0">
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white"
                    >Operational tasks</b-card-title
                  >
                  <span class="h2 font-weight-bold mb-0 text-white">297/300</span>
                  <base-progress class="progress-xs mt-3 mb-0" type="success" :value="98"></base-progress>
                </b-col>
                <b-col md="auto">
                  <b-dropdown no-caret right toggle-class="btn btn-sm btn-neutral mr-0">
                    <template v-slot:button-content>
                      <i class="fas fa-ellipsis-h"></i>
                    </template>
                    <b-dropdown-item>Reload</b-dropdown-item>
                    <b-dropdown-item>New task</b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
              <p class="mt-3 mb-0 text-sm">
                <a href="#!" class="text-nowrap text-white font-weight-600">See details</a>
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>

    <!-- Charts -->
    <b-container fluid class="mt--6">
      <b-card-group deck class="flex-column flex-xl-row">
        <card>
          <b-row align-v="center" slot="header">
            <b-col>
              <h6 class="text-uppercase text-muted ls-1 mb-1">Overview</h6>
              <h5 class="h3 mb-0">Deployed traps</h5>
            </b-col>
          </b-row>
          <line-chart
            :height="350"
            ref="bigChart"
            :chart-data="bigLineChart.chartData"
            :extra-options="bigLineChart.extraOptions"
          ></line-chart>
        </card>
        <card header-classes="bg-transparent">
          <b-row align-v="center" slot="header">
            <b-col>
              <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
              <h5 class="h3 mb-0">Total orders</h5>
            </b-col>
          </b-row>
          <bar-chart :height="350" ref="barChart" :chart-data="redBarChart.chartData"></bar-chart>
        </card>
      </b-card-group>
    </b-container>
  </div>
</template>

<style></style>

<script>
import * as chartConfigs from '@/components/Charts/config'
import LineChart from '@/components/Charts/LineChart'
import BarChart from '@/components/Charts/BarChart'
import BaseHeader from '@/components/BaseHeader'
import BaseProgress from '@/components/BaseProgress'
import StatsCard from '@/components/Cards/StatsCard'

export default {
  components: {
    LineChart,
    BarChart,
    BaseHeader,
    BaseProgress,
    StatsCard
  },
  data() {
    return {
      bigLineChart: {
        chartData: {
          datasets: [
            {
              label: 'Performance',
              data: [0, 20, 10, 30, 15, 40, 20, 60, 60]
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        extraOptions: chartConfigs.blueChartOptions
      },
      redBarChart: {
        chartData: {
          labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [
            {
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }
          ]
        }
      }
    };
  }
};
</script>
